/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";

export class servicereference extends IceEntity {
  service_reference_key: string = "";
  medical_service_key: string = "";
  other_items_key: string = "";
  subscriber_key: string = "";
  coverage_key: string = "";
  payer_key: string = "";
  benefit_information_key: string = "";
  purchase_order_key: string = "";
  purchase_delivery_key: string = "";
  purchase_order_service_key: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "SERVICE_REFERENCE";
  }
}
